import BigNumber from 'bignumber.js'
import { useMemo } from 'react'

import type { WalletPosition } from '@root/entities/position'

const MAX = BigNumber(Number.MAX_SAFE_INTEGER)

export type ChartEntrySwap = {
  type: 'buy' | 'sell'
  amount: BigNumber
  timestamp: Date
}
export type ChartEntry = {
  timestamp: Date
  price: BigNumber
  buys: number
  sells: number
}

export const useChartData = ({
  rawEntries,
}: {
  rawEntries: Array<WalletPosition.ChartRawEntry>
}) => {
  const { entries, min, max } = useMemo(() => {
    let max = BigNumber(0)
    let min = MAX

    const entries = rawEntries.map((it): ChartEntry => {
      const priceBn = BigNumber(it.price)
      if (priceBn.gt(max)) {
        max = priceBn
      }
      if (priceBn.lt(min)) {
        min = priceBn
      }
      const buys = it.swaps.filter((it) => it.type === 'buy').length
      return {
        timestamp: new Date(it.timestamp),
        price: priceBn,
        buys: buys,
        sells: it.swaps.length - buys,
      }
    })
    return { entries, min, max }
  }, [rawEntries])

  const priceDifference = max.minus(min)
  const boundary = priceDifference.multipliedBy(10 / 100)

  return {
    entries,
    minPrice: min,
    maxPrice: max,
    minBoundary: min.minus(boundary),
    maxBoundary: max,
  }
}
